"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SearchListItem_1 = require("./SearchListItem");
var firebase_1 = require("./firebase");
var Header_1 = require("./Header");
var react_notification_1 = require("react-notification");
var Search_1 = require("./Search");
var VoteService_1 = require("./VoteService");
var TokenService_1 = require("./TokenService");
var operators_1 = require("rxjs/operators");
var ajax_1 = require("rxjs/ajax");
var ArtistResponse = /** @class */ (function () {
    function ArtistResponse() {
    }
    return ArtistResponse;
}());
exports.ArtistResponse = ArtistResponse;
var Album = /** @class */ (function (_super) {
    __extends(Album, _super);
    function Album(props) {
        var _this = _super.call(this, props) || this;
        _this.voteService = new VoteService_1.VoteService();
        return _this;
    }
    Object.defineProperty(Album.prototype, "eventId", {
        get: function () {
            return this.props.match.params.eventId;
        },
        enumerable: true,
        configurable: true
    });
    Album.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({ votes: {} });
        this.loadData(this.props.match.params.albumId);
        this.voteService
            .loadVoteStatus(this.props.match.params.eventId)
            .subscribe(function (votes) { return _this.setState({ votes: votes }); });
    };
    Album.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        this.loadData(nextProps.match.params.albumId);
        this.voteService
            .loadVoteStatus(nextProps.match.params.eventId)
            .subscribe(function (votes) { return _this.setState({ votes: votes }); });
    };
    Album.prototype.loadData = function (albumId) {
        var _this = this;
        var url = "https://api.spotify.com/v1/albums/" + albumId;
        TokenService_1.tokenService.token
            .pipe(operators_1.first(), operators_1.flatMap(function (token) {
            return ajax_1.ajax({
                url: url,
                headers: {
                    authorization: "Bearer " + token.access_token
                },
                crossDomain: true,
                method: "GET",
                responseType: "json"
            });
        }))
            .subscribe(function (r) {
            _this.setState({ response: r.response });
        });
    };
    Album.prototype.addToPlaylist = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.state.votes[item.id] = true;
                        return [4 /*yield*/, firebase_1.app
                                .database()
                                .ref("/events/" + this.eventId + "/playlistQueue")
                                .push(item.id)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.voteService.vote(this.eventId, item.id)];
                    case 2:
                        _a.sent();
                        this.setState({ notification: true });
                        setTimeout(function () { return _this.setState({ notification: false }); }, 1000);
                        return [2 /*return*/];
                }
            });
        });
    };
    Album.prototype.voteStatus = function (id) {
        if (!this.state.votes)
            return true;
        if (this.state.votes[id])
            return true;
        return false;
    };
    Album.prototype.render = function () {
        var _this = this;
        var style = {
        // display: "flex"
        };
        var styleElement = {
            flex: 1
        };
        var headerStyle = {
            textAlign: "center",
            fontSize: "13px",
            margin: "10px"
        };
        var body = null;
        if (this.state.response) {
            body = (React.createElement("div", { style: style },
                React.createElement("div", { style: styleElement },
                    React.createElement("div", { style: headerStyle },
                        React.createElement("b", null, this.state.response.name)),
                    this.state.response.tracks.items.map(function (i) { return (React.createElement(SearchListItem_1.SearchListItem, { key: i.id, item: i, clickEnabled: !_this.voteStatus(i.id), onClick: function () { return _this.addToPlaylist(i); }, itemRenderer: function (i) { return Search_1.renderTrack(i); } })); }))));
        }
        return (React.createElement("div", null,
            React.createElement(Header_1.Header, { icon: "plus", text: "Musik hinzuf\u00FCgen" }),
            body,
            React.createElement(react_notification_1.Notification, { isActive: this.state.notification, message: "Track hinzugef\u00FCgt" })));
    };
    return Album;
}(React.Component));
exports.Album = Album;
